/**
 * Shared constants for onboarding dashboard components.
 */

export const statusColors: Record<string, string> = {
  draft: 'bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-200',
  pending_approval: 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200',
  pending: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200',
  sent: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  opened: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
  accepted: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  declined: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
  expired: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
  cancelled: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
  invited: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  registered: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-200',
  documents_pending: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200',
  questionnaires_pending: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
  submitted: 'bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-200',
  under_review: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
  more_info_required: 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200',
  approved: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  // CR-5953: WIP — supplier accepted invitation + activated account but
  // hasn't yet submitted their questionnaires. Sits in the Invited tab
  // alongside still-out invitations until questionnaire submission.
  wip: 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200',
};
